import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/internal/operators';
import { environment } from 'src/environments/environment';
import { Device } from '../models/classes/device';
import { Unregister } from '../models/classes/unregister';
import { DeviceValidation } from '../models/classes/device-validation';
import { User } from '../models/classes/user';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  ip = environment.ipServer;

  private userUrl = `${this.ip}/api/deviceregistration`;
  device: BehaviorSubject<Device>;
  devices: Device[] = [];
  selectedDevice: Device;
  constructor(private http: HttpClient) {
    this.device = new BehaviorSubject<Device>(null);
  }

  getDevices(): Observable<Device[]> {
    return this.http.get<Device[]>(this.userUrl).pipe(
      map((data) => (this.devices = data)),
      catchError(this.handleError)
    );
  }

  deviceById(id: number){
    const url = `${this.userUrl}/GetDevice/${id}`;
    return this.http.get<Device>(url);
  }

  lastLoggedInDevice(user: User){
    const url = `${this.ip}/api/Device/GetDevice`;
    return this.http.post<Device>(url, user, {observe: 'response'});
  }

  get deviceId(): Observable<Device> {
    return this.device.asObservable();
  }

GetDeviceCode(undergister:Unregister){
  const url = `${this.userUrl}/GetDevId`;
  return this.http.post(url,undergister,{responseType: 'text'});
}

validateAndRemove(dev:DeviceValidation){
  const url = `${this.userUrl}/ValidateAndRemove`;
  return this.http.post(url,dev,{observe: 'response'});
}

  private handleError(err: HttpErrorResponse) {
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
